import { Employee, Invoice } from "@/v2/types";
import { apiClientWithRefreshToken } from "../apiClient";

export type Dashboard = {
    expired_employees: Employee[];
    ar_employees_id_expiry: Employee[];
    ar_employees_id_expiry_next_week: Employee[];
    expired_employees_count: number;
    employees_missing_id_expiry: Employee[];
    payable_invoice_total_due_amount: number;
    payable_invoice_over_due: Invoice[];
    margins: any;
    receivable_invoice_over_due: Invoice[];
    receivable_invoice_total_due_amount: number;
    expired_employees_count_in_this_week: number;
    percent_employees_expire_in_this_week: number;
    invoice_dues: { due_date: string; invoice_count: number }[];
    total_margin: number;
    total_client_rate_this_month: number;
    total_client_rate_last_month: number;
    total_supplier_rate_last_month: number;
    total_supplier_rate_this_month: number;
    percentage_ar_employees_expire_in_this_week: number;
    plant_id_expiring_soon_count: number;
    plant_id_expiring_soon_employees: number;
};

const FetchAnalytics = async (year?: any): Promise<Dashboard> => {
    const res = await apiClientWithRefreshToken({
        url: "/analytics",
        method: "GET",
        params: year && {
            year: year,
        },
    });

    return res.data;
};

export default FetchAnalytics;
